import { ApiReducer as api } from 'reactifi-local';
import { routerReducer } from 'react-router-redux';
import topicReducer from './topicReducer';

export default {
  api,
  routing: routerReducer,
  topics: topicReducer,
};
